import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { SchoolServices } from '../../../services';

/**
 * Generated class for the MenuPartialDishesSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-classrooms-partial-students-selected',
    templateUrl: 'classrooms-partial-students-selected.html',
})
export class ClassroomsPartialStudentsSelectedPage {


    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public schoolServices: SchoolServices) {

    }

    delete(index) {
        this.schoolServices.classroom_students_array_tmp.splice(index, 1);
    }


}



// WEBPACK FOOTER //
// ./src/pages/schools/classrooms-create/classrooms-create-students-select/classrooms-partial-students-selected/classrooms-partial-students-selected.ts